import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-zoomplus-icon',
  templateUrl: './design-zoomplus.component.html'
})
export class DesignZoomPlusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
